import React, { useState, FormEvent, useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { Suggest, Suggest2, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Checkbox, Radio, RadioGroup, Switch, Alert, Dialog, DialogBody, Callout } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";


import { AxiosInstance } from 'axios';

import * as utils from "../utils";

import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import svgWait2 from '../svg/wait2.gif'

import { FBSExpiryInfo } from '../Types'
import { SystemHeader } from '../CommonUI';
import { Pagination, PageInfo } from '../CommonUI';

import i18next from 'i18next';


var GsbFlag: any;

var UserID: string;
var PgmCode = "M0007" ;
var isReqAuth2:boolean = false ;

interface FBSExpiryMastViewProps {
    gsb: AxiosInstance,
    ExpiryInfo: FBSExpiryInfo,
    baseUrl?: string,
    token?: string | null,
    onPrevRec?: () => void,
    onNew?: () => void,
    onEdit?: () => void,
    onDelete?: () => void,
    onNextRec?: () => void,
}


export function FBSExpiryMastView({ gsb, ExpiryInfo = {} as FBSExpiryInfo, baseUrl = "", token = "", onPrevRec = () => { }, onNew = () => { }, onEdit = () => { }, onDelete = () => { }, onNextRec = () => { } }: FBSExpiryMastViewProps) {


    const { t, i18n } = useTranslation();    

    const [isReadOnly, setisReadOnly] = useState(false)
    const [isReqAuth, setisReqAuth] = useState(false)
    const [isDeletePress, setisDeletePress] = useState(false)

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
 
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])
    
/*
    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])
*/

    useEffect(() => {
        setisReadOnly(false)
        setisReqAuth(false)
        isReqAuth2 = false
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            //setisReqAuth(true)
                            //isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID, ExpiryInfo])

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    if (! ("d_Comdy" in ExpiryInfo)) return null


    return (
        <div>
            {/* define add,change,delete button */}
            <div className="Row">
                <Button className="Col-1-1" icon="direction-left" onClick={() => onPrevRec()} >Prev</Button>
                
                <Button className="Col-2-1" disabled={isReadOnly} icon="add" onClick={() => onNew() } >New</Button>
                <Button className="Col-3-1" disabled={isReadOnly} icon="edit" onClick={() => onEdit() } >Edit</Button>
                <Button className="Col-4-1" disabled={isReadOnly} icon="delete" onClick={() => setisDeletePress(true) } >Delete</Button>
                    <Alert
                        cancelButtonText="Cancel"
                        confirmButtonText="Delete"
                        canEscapeKeyCancel={true}
                        icon="trash"
                        intent={Intent.DANGER}
                        isOpen={isDeletePress}
                        onCancel={ () => setisDeletePress(false) }
                        onConfirm={ () => { onDelete(); setisDeletePress(false) } }
                    >
                        <p>
                            Are you sure to Delete ?
                        </p>
                    </Alert>
                
                <Button className="Col-5-1" icon="direction-right" onClick={() => onNextRec()} >Next</Button>
            </div>

            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label="Commodity">
                    <InputGroup readOnly value={ExpiryInfo.d_Comdy} />
                </FormGroup>
                <FormGroup className="Col-2-3" label="Name">
                    <div id="DispText">{ExpiryInfo.d_ComdyName}</div>
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="D.Month">
                    <InputGroup readOnly value={ExpiryInfo.d_DMon} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Last Trading Date" subLabel={ExpiryInfo.d_SettlMeth === "P" ? "" : "Options Expiry Date"}>
                    <InputGroup readOnly value= {utils.dispDate(ExpiryInfo.d_LastDay, GsbFlag.dateFormat)} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Final Settlement Date" subLabel={ExpiryInfo.d_SettlMeth === "P" ? "Physical Settlement" : "Futures Cash Settlement"}>
                    <InputGroup readOnly value= {utils.dispDate(ExpiryInfo.d_Expiry, GsbFlag.dateFormat)} />
                </FormGroup>
            </div>
        </div>
    )
}

interface FBSExpiryMastEditProps {
    gsb: AxiosInstance,
    ExpiryInfo?: FBSExpiryInfo,
    isNew?: boolean,
    onSave?: (stk: FBSExpiryInfo) => void,
    onCancel?: () => void,
}

export function FBSExpiryMastEdit({ gsb, ExpiryInfo = {} as FBSExpiryInfo, isNew = false, onSave = () => { }, onCancel = () => { } }: FBSExpiryMastEditProps) {

    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<FBSExpiryInfo>()

    const { t, i18n } = useTranslation();    

    const [isReadOnly, setisReadOnly] = useState(false)
    const [isReqAuth, setisReqAuth] = useState(false)

    const [ComdyValue, setComdyValue] = useState(ExpiryInfo.d_Comdy)
    const [ComdyNameValue, setComdyNameValue] = useState(ExpiryInfo.d_ComdyName)

    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
 
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        // Call reset to get the values of record ClientTranInfo 
        if ("d_Comdy" in ExpiryInfo) {
            reset(ExpiryInfo)
        }
    }, [ExpiryInfo, reset])


    useEffect(() => {
        // Some components (e.g. Suggest) don't have ref to use with react-hook-form, so register the fields manually and call setValue when item is selected
        // register({ name: "d_FieldName" })
    }, [register])


    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])

    useEffect(() => {
        (async () => {
            try {
                const res = await gsb.post('/fbs/Master', {sb_data: "", cPgmId: "ComdyMast", cAction: "GetComdyInfo", cComdy: ComdyValue})
                
                if ( ComdyValue.trim().length > 0 && res.data.count > 0 )
                {
                    setComdyNameValue(res.data.data[0].d_ComdyName)

                } else { 
                    setComdyNameValue("")
                }
               
            } catch (error) {
                //showErrorBox(error)
            }
        })()
    }, [gsb, ComdyValue])

    if (! isNew && ! ("d_Comdy" in ExpiryInfo)) return null

   
    const onSubmit = (data: FBSExpiryInfo) => {
        // put value to json/field before write database dbf

        (async () => {
            try {
                const res = await gsb.post('/fbs/Master', {sb_data: data, cPgmId: "ExpiryMast", cAction: "ExpiryMastValidate", isNew: isNew})

                if (! res.data.ok) {
                    for (let j = 0; j < res.data.data.length; j++) {
                      
                        setError(res.data.data[j][0], {
                           message: res.data.data[j][1]
                        }); 
                    }

                    return
                }
                onSave(data)

            } catch (error) {
                showErrorBox(error)
            }
        })()
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    return (
        <form onKeyDown={handleHotkey}>
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>Cancel</Button>
                <Button className="Col-2-1" icon="tick" onClick={handleSubmit(onSubmit)}>Save</Button>
                { isReqAuth && 
                    <Callout className="Col-6-2"
                        icon="warning-sign"
                        intent={Intent.WARNING}
                    >
                        Authorization Required
                    </Callout>
                }

             </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label="Commodity" labelFor="inputComdy" labelInfo="*">
                    <InputGroup disabled={!isNew} id="inputComdy" name="d_Comdy" value={ComdyValue} placeholder="Commodity ..." onChange={utils.handleStringChange(s => setComdyValue(s.toUpperCase()))} inputRef={register({ required: true , maxLength: 5}) } />
                    {errors.d_Comdy && errors.d_Comdy.type === "required" && <span id="Err_msg">Commodity cannot be Blank</span>}
                    {errors.d_Comdy && errors.d_Comdy.type === "maxLength" && <span id="Err_msg">Max length is 5</span>}
                    {errors.d_Comdy && errors.d_Comdy.types && <span id="Err_msg">{errors.d_Comdy.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-3" label="Commodity Name" labelFor="inputComdyName">
                    <div id="DispText">{ComdyNameValue}</div>
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="D.Month" labelFor="inputDMon" labelInfo="*">
                    <InputGroup disabled={!isNew} id="inputDMon" name="d_DMon" defaultValue={ExpiryInfo.d_DMon} placeholder="D.Month ..." onChange={utils.handleStringChange(s => setValue("d_DMon", s.toUpperCase()))} inputRef={register({ required: true , maxLength: 7}) } />
                    {errors.d_DMon && errors.d_DMon.type === "required" && <span id="Err_msg">D.Month cannot be Blank</span>}
                    {errors.d_DMon && errors.d_DMon.type === "maxLength" && <span id="Err_msg">Max length is 7</span>}
                    {errors.d_DMon && errors.d_DMon.types && <span id="Err_msg">{errors.d_DMon.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Last Trading Date" labelFor="d_LastDay" subLabel={ExpiryInfo.d_SettlMeth === "P" ? "" : "Options Expiry Date"}>
                    <InputGroup id="d_LastDay" name="d_LastDay" defaultValue="" type="date" inputRef={register} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Final Settlement Date" labelFor="d_Expiry" subLabel={ExpiryInfo.d_SettlMeth === "P" ? "Physical Settlement" : "Futures Cash Settlement"}>
                    <InputGroup id="d_Expiry" name="d_Expiry" defaultValue="" type="date" inputRef={register} />
                </FormGroup>
            </div>
        </form>
    )
}

interface FBSExpiryMastMainProps {
    gsb: AxiosInstance
}

// const toaster = Toaster.create({
//     position: Position.TOP,
// })

function FBSExpiryMastMain({ gsb }: FBSExpiryMastMainProps) {

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />

    let url = document.location.toString()
    let qString = url.substr(url.indexOf("?"))

    let { comdy: defaultSearchValue = "", dmon: defaultSearchValue2 }: { comdy: string, dmon: string } = useParams()

    const [isReadOnly, setisReadOnly] = useState(false)

    const [data, setData] = useState([] as FBSExpiryInfo[])

    const [searchKey, setSearchKey] = useState("market")
    const [searchValue, setSearchValue] = useState(defaultSearchValue)
    const [searchValue2, setSearchValue2] = useState(defaultSearchValue2)

    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [MoblieDev, setMoblieDev] = useState(false)
    const [ShowWait, setShowWait] = useState(false)
    const [searchLimit, setSearchLimit] = useState(50)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("list")
    const [currentExpiryInfo, setcurrentExpiryInfo] = useState({} as FBSExpiryInfo)

    const [currentMode, setCurrentMode] = useState("show")
    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                UserID = res.data.Flag.UserID
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) 
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        setisReadOnly(false)
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    //console.log("ExpiryMastMain UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID])



    const PrevRecProcess = async (ExpiryInfo: FBSExpiryInfo) => {
        try {
            const res = await gsb.post('/fbs/Master', {sb_data: ExpiryInfo, cPgmId: "ExpiryMast", cAction: "PrevRec"})
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Comdy+data[i].d_DMon === res.data.data.d_Comdy+res.data.data.d_DMon) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setcurrentExpiryInfo(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const DeleteProcess = async (ExpiryInfo: FBSExpiryInfo) => {
        try {
            //console.log("call DeleteProcess", stk)
            const res = await gsb.post('/fbs/Master', {sb_data: ExpiryInfo, cPgmId: "ExpiryMast", cAction: "DelRec"})
            utils.showSuccess("D.Month " + ExpiryInfo.d_Comdy+" "+ExpiryInfo.d_DMon + " record deleted")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Comdy+data[i].d_DMon === res.data.data.d_Comdy+res.data.data.d_DMon) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setcurrentExpiryInfo(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const NextRecProcess = async (ExpiryInfo: FBSExpiryInfo) => {
        try {
            const res = await gsb.post('/fbs/Master', {sb_data: ExpiryInfo, cPgmId: "ExpiryMast", cAction: "NextRec"})
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Comdy+data[i].d_DMon === res.data.data.d_Comdy+res.data.data.d_DMon) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setcurrentExpiryInfo(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const newOnSave = async (ExpiryInfo: FBSExpiryInfo) => {
        try {
            const res = await gsb.post('/fbs/Master', {sb_data: ExpiryInfo, cPgmId: "ExpiryMast", cAction: "AddRec"})
            utils.showSuccess("D.Month " + ExpiryInfo.d_Comdy+" "+ExpiryInfo.d_DMon + " record added")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Comdy+data[i].d_DMon === res.data.data.d_Comdy+res.data.data.d_DMon) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setcurrentExpiryInfo(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }

    const editOnSave = async (ExpiryInfo: FBSExpiryInfo) => {
        try {
            const res = await gsb.post('/fbs/Master', {sb_data: ExpiryInfo, cPgmId: "ExpiryMast", cAction: "UpdateRec"})
            utils.showSuccess("D.Month " + ExpiryInfo.d_Comdy+" "+ExpiryInfo.d_DMon + " record saved")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Comdy+data[i].d_DMon === res.data.data.d_Comdy+res.data.data.d_DMon) {
                    data[i] = { ...data[i], ...res.data.data }
                    //console.log("editOnSave data", i, data)
                    setData(data)
                    break
                }
            }
            //console.log("editOnSave res.data.data", res.data.data)
            setcurrentExpiryInfo(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }

    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()

        setShowWait(true)
        setnPage(1)
        let m_limit = searchLimit
        if ( selectedTabId === "detail" ) {
            m_limit = 1
        }

        if ( utils.getDeviceType()) {
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }
        
        try {
            //console.log("ExpiryMastMain onsubmit called", data)
            if ( m_limit > 1 ) {
                const res = await gsb.post('/fbs/Master',
                {   sb_data: {
                        by: searchKey,
                        start: searchValue,
                        start2: searchValue2,
                        nPage: 1,
                        limit: m_limit,
                        backward: searchBackward,
                        filters: {
                        }, 
                    },
                    cPgmId: "ExpiryMast",
                    cAction: "ListRec",
                });

                //console.log("onSubmit res.data.data", res.data.data)
                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setcurrentExpiryInfo(res.data.data[0])
                }
                
                if ( res.data.count > 0 ) {
                    const aPageNumber1 = []
                    if ( res.data.count > 0 ) {
                        setnTotalPage(Math.ceil(res.data.count / searchLimit))
                        for ( let j = 1; j <= Math.ceil(res.data.count / searchLimit); j++ ) {
                            aPageNumber1.push({n: j});
                        }
                        setaPageNumber(aPageNumber1)
                    }
                }
    
            } else {
                const res = await gsb.post('/fbs/Master',
                {   sb_data: {
                        d_Comdy: searchValue,
                        d_DMon: searchValue2,
                        nPage: 1,
                        limit: m_limit,
                    },
                    cPgmId: "ExpiryMast",
                    cAction: "GetRec",
                });

                if ( res.data.ok ) {
                    //console.log("GetRec res.data.data", res.data.data)
                    setcurrentExpiryInfo(res.data.data)
                    setCurrentMode("show")
                } else {
                    //alert(res.data.data)
                    setisShowAlert2(true)
                    setShowAlert2Msg(res.data.data)
                }
            }

            setShowWait(false)
        } catch (error) {
            setShowWait(false)
            utils.showError(error)
        }
    }

    useEffect(() => {
        if (defaultSearchValue.length > 0) {
            setShowWait(true)
            setnPage(1)
            if ( nPage > 0 ) {
                //setcPrintMode("PS")
            } 
    
            (async () => {
                //console.log("ExpiryMastMain useEffect length > 0  called", data)
                const res = await gsb.post('/fbs/Master',
                    {   sb_data: {
                            by: "market",
                            start: defaultSearchValue,
                            start2: defaultSearchValue2,
                            nPage: 1,
                            limit: 1,
                        },
                        cPgmId: "ExpiryMast",
                        cAction: "ListRec",
                    });

                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setcurrentExpiryInfo(res.data.data[0])
                }
                setShowWait(false)
            })()
        }
    }, [gsb, defaultSearchValue, defaultSearchValue2])

    //Press page No 1 2 3 4
    useEffect(() => {
        if ( nPage > 0 && nPage <= nTotalPage && selectedTabId == "list" ) {
    
            setShowWait(true)
            if ( nPage > 0 ) {
                //setcPrintMode("S")
            } 
    
            (async () => {
                try {
                    const res = await gsb.post('/fbs/Master',
                    {   sb_data: {
                            by: searchKey,
                            start: searchValue,
                            start2: searchValue2,
                            nPage: nPage,
                            limit: searchLimit,
                            backward: searchBackward,
                            filters: {
                            }, 
                        },
                        cPgmId: "ExpiryMast",
                        cAction: "ListRec",
                    });

                    setData(res.data.data)
                    if (res.data.data.length > 0) {
                        setcurrentExpiryInfo(res.data.data[0])
                    }
                    setShowWait(false)
        
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, nPage, selectedTabId])
    

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    // currentMode = show
    let detail = <FBSExpiryMastView gsb={gsb} ExpiryInfo={currentExpiryInfo} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentExpiryInfo)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentExpiryInfo)} onNextRec={() => NextRecProcess(currentExpiryInfo)}></FBSExpiryMastView>
    switch (currentMode) {
        case "new":
            //console.log("currentMode = new")
            detail = <FBSExpiryMastEdit gsb={gsb} isNew onSave={newOnSave} onCancel={() => { setCurrentMode("show"); setSelectedTabId("detail") } }></FBSExpiryMastEdit>
            break
        case "edit":
            //console.log("currentMode = edit")
            detail = <FBSExpiryMastEdit gsb={gsb} ExpiryInfo={currentExpiryInfo} onSave={editOnSave} onCancel={() => setCurrentMode("show")}></FBSExpiryMastEdit>
            break
        }

    let pagination = <Pagination nPage={nPage} nTotalPage={nTotalPage} aPageNumber={aPageNumber} setnPage={(n)=>setnPage(n)}></Pagination>
    
    let list = <>
        <div className="Row">
            <Button className="Col-1-1" disabled={isReadOnly} icon="add" onClick={() => { setCurrentMode("new"); setSelectedTabId("detail") }}>New</Button>
        </div>
        <div className="Spacing-V-16" />
        {ShowWait && <div>{imgWait}</div> }
        {nPage > 0 && pagination}
        {/* display search list */}
        <HTMLTable striped interactive condensed>
            <thead>
                <th className="TCol-100">Commodity</th>
                <th className="TCol-100">D.Month</th>
                <th className="TCol-100">Last Day</th>
                <th className="TCol-100">Expiry</th>
            </thead>
            <tbody id="ma_tr">
                {data.map((ExpiryInfo, i) =>
                    <tr key={i} onDoubleClick={() => { setSelectedTabId("detail") }}>
                        <td onClick={() => { setcurrentExpiryInfo(ExpiryInfo) ; MoblieDev && setSelectedTabId("detail") }}>{ExpiryInfo.d_Comdy}</td>
                        <td onClick={() => { setcurrentExpiryInfo(ExpiryInfo) ; MoblieDev && setSelectedTabId("detail") }}>{ExpiryInfo.d_DMon}</td>
                        <td onClick={() => { setcurrentExpiryInfo(ExpiryInfo) ; MoblieDev && setSelectedTabId("detail") }}>{ExpiryInfo.d_LastDay}</td>
                        <td onClick={() => { setcurrentExpiryInfo(ExpiryInfo) ; MoblieDev && setSelectedTabId("detail") }}>{ExpiryInfo.d_Expiry}</td>
                        {/* <td onClick={() => { setcurrentExpiryInfo(ExpiryInfo) }}>{ExpiryInfo.d_Action}</td> */}
                    </tr>
                )}
            </tbody>
        </HTMLTable>
        {ShowWait && nTotalPage > 0 && <div>{imgWait}</div> }
        {nPage > 0 && pagination}
    </>

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>
    return (
        <>

            <form onSubmit={onSubmit}>
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>Futures Month & Expiry Date</H3>
                    <div className="Spacing-V-16" />
                    <div className="Row">
                        {/* define search key */}
                        <FormGroup className="Col-1-5" label="Search for" labelFor="inputSearchValue">
                            <ControlGroup fill>
                                <HTMLSelect className={Classes.FIXED} value={searchKey} onChange={utils.handleStringChange(s => setSearchKey(s))}>
                                    <option value="comdy">Commodity</option>
                                </HTMLSelect>
                                <InputGroup
                                    id="inputSearchValue"
                                    placeholder="Search"
                                    value={searchValue}
                                    onChange={utils.handleStringChange(s => setSearchValue(s))}
                                    leftIcon="search"
                                />
                                <InputGroup
                                    id="inputSearchValue2"
                                    placeholder=""
                                    value={searchValue2}
                                    onChange={utils.handleStringChange(s => setSearchValue2(s))}
                                    rightElement={<Button icon={IconNames.ARROW_RIGHT} disabled={(selectedTabId === "detail" && ! (searchKey == "comdy"))} minimal type="submit"></Button>}
                                />
                            </ControlGroup>
                        </FormGroup>
                        <Button className="Col-6-1 Button-LabeledFormGroup" icon="search" disabled={(selectedTabId === "detail" && ! (searchKey == "comdy"))} type="submit" >{(selectedTabId === "detail") ? "Search" : "List"}</Button>
                        </div>
                    <Tabs onChange={(newTabId) => setSelectedTabId(newTabId as string)} selectedTabId={selectedTabId}>
                        <Tab id="list" title="List" panel={list} />
                        <Tab id="detail" title="Detail" panel={detail} />
                    </Tabs>
                </Card>

                <div className="Spacing-V-16"></div>
                    <Alert
                        confirmButtonText="OK"
                        icon="tick-circle"
                        intent={Intent.SUCCESS}
                        isOpen={isShowAlert1}
                        onCancel={ () => setisShowAlert1(false) }
                        onConfirm={ () => { setShowAlert1Msg(""); setisShowAlert1(false) } }
                    >
                        <p>
                            {ShowAlert1Msg}
                        </p>
                    </Alert>
                    <Alert
                        confirmButtonText="OK"
                        icon="cross"
                        intent={Intent.WARNING}
                        isOpen={isShowAlert2}
                        onCancel={ () => setisShowAlert2(false) }
                        onConfirm={ () => { setShowAlert2Msg(""); setisShowAlert2(false) } }
                    >
                        <p>
                            {ShowAlert2Msg}
                        </p>
                    </Alert>
            </form>
        </>
    );
}

export default FBSExpiryMastMain